import React, { Suspense } from 'react';
import ReactGA from 'react-ga4';
import { CSSTransitionGroup } from 'react-transition-group';// ES6
import Share from './Share';
import AgentDetails, {AgentInfo} from './AgentDetails';
// import PropertyContent from './PropertyContent';
import PropertyContentNav from '../PropertyContentNav';
import Database from '../../../../Helpers/Database.js'
import HubSpot from '../../../../Helpers/HubSpot';
const PropertyContent = React.lazy(() => import(/* webpackChunkName: "PropertyContent" */'./PropertyContent'));
import './styles.scss';
const db = new Database;
const hubSpot = new HubSpot;

export default class PropertyDetailBody extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            agentSet: false,
            agent: {},
            buyerAgent: {},
            secondaryAgentSet: false,
            secondaryAgent: {},
            updateCount: 0,
            slideIndex: 0,
            contact: false,
            user: false,
            displayMailerOption: true,
            addressForm: false,
            // form fields
            submitted: false,
            submitButtonText: 'Submit',
            submitButtonDisabled: false,
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            message: '',
            rmiError: '',
            mailer: false,
            address: {
                street: '',
                street_2: '',
                city: '',
                state: '',
                zip: '',
                country: ''
            },
            addressErrors: {
                hasError: false,
                street: false,
                street_2: false,
                city: false,
                state: false,
                zip: false,
                country: false
            }
        };
    }

    componentDidMount() {
        const TRACKING_ID = "G-JRDY0PZRZR";
        ReactGA.initialize(TRACKING_ID);

        this.fetchUser();
        this.fetchAgent(this.props.property.agent);
        this.fetchSecondaryAgent(this.props.property.secondary_broker);
        this.fetchBuyerAgent(this.props.property.buyer_agent);
    }

    handleAddressSubmit = () => {

        let { user, address, addressErrors } = this.state;

        Object.keys(addressErrors).forEach(key => {
            addressErrors[key] = false;
        })
        this.setState({ addressErrors })

        Object.keys(address).forEach(key => {
            if (['street', 'city', 'state', 'zip'].includes(key) && !address[key]) {
                addressErrors[key] = true;
                addressErrors['hasError'] = true;
            }
        })
        this.setState({ addressErrors })

        if (!addressErrors.hasError) {
            if (user.id) {
                this.updateUser()
            }
            this.setState({
                mailer: false,
                addressForm: false
            }, () => {
                this.handleSubmit()
            })
        }
    }


    updateUser = () => {

        let { user, address } = this.state;
        let { id, subscription_prefs } = user;

        if (!subscription_prefs.length) {
            subscription_prefs = ['mailer']
        } else if (!subscription_prefs.includes('mailer')) {
            subscription_prefs = [...subscription_prefs, 'mailer']
        }

        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
            body: new URLSearchParams({
                action: 'update_user',
                id,
                subscription_prefs,
                address: JSON.stringify(address)
            })
        })
            .then(hubSpot.saveUser())

    }

    toggleContactForm = () => {
        console.log('clicked')
        let { contact } = this.state;
        this.setState({ contact: !contact })
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value })
        this.setState({ rmiError: '' })
    }

    handleCheckbox = () => {
        let { mailer } = this.state;
        mailer = !mailer;
        this.setState({ mailer })
    }

    handleAddressChange = (e) => {
        const { name, value } = e.target;
        let { address } = this.state;
        address[name] = value;
        this.setState({ address })
    }

    handleSubmit = (e) => {

        if (e) {
            e.preventDefault()
        }
        const { firstName, lastName, email, phone, message, mailer, address, user } = this.state;
        this.setState({ 
            submitButtonText: 'Sending...',
            submitButtonDisabled: true
        });

        if (mailer) {
            this.setState({ addressForm: true })
        } else {
            db.ajaxCall({
                action: 'rmi_form',
                firstName,
                lastName,
                email,
                phone,
                message,
                propertyId: this.props.property.id
            })
                .then(res => {
                    console.log({ res });
                    if (res.error) {
                        this.setState({ 
                            rmiError: res.error,
                            submitButtonText: 'Submit',
                            submitButtonDisabled: false
                        })
                    }
                    if (res.success) {
                        this.setState({ 
                            submitted: true,
                            submitButtonText: 'Sent',
                            submitButtonDisabled: false
                        })

                        ReactGA.event({
                            category: 'RMI Submission',
                            action: this.state.agent.first_name + ' ' + this.state.agent.last_name,
                            label: this.props.property.title + ', ' + this.props.property.loc_address.state
                        });

                    }
                })
                .catch(err => console.log(err))

            let action = user.id ? 'prepare_lob' : 'non_user_prepare_lob';

            db.ajaxCall({
                action,
                propertyId: this.props.property.id,
                address: JSON.stringify(address),
                fullName: `${firstName} ${lastName}`
            })
                .catch(err => console.log(err))
        }
        fbq('track', 'Lead');
    }

    fetchUser = () => {

        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
            body: new URLSearchParams({
                action: 'fetch_user'
            })
        })
            .then(res => res.json())
            .then(
                user => {
                    if (user.id) {
                        this.setState({
                            user: user,
                            firstName: user.first_name,
                            lastName: user.last_name,
                            email: user.email,
                            phone: user.phone,
                            displayMailerOption: !user.subscription_prefs.includes('mailer')
                        })
                    }
                }
            )
            .catch(err => console.log(err))

    }

    fetchAgent = (id) => {
        let { agentSet } = this.state;
        if (agentSet) return;

        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
            body: new URLSearchParams({
                action: 'fetch_agent',
                id: id
            })
        })
            .then(res => res.json())
            .then(
                agent => this.setState({ agent: agent, agentSet: true })
            )
            .catch(err => console.log(err))

    }

  fetchAgent = (id) => {
    let { agentSet } = this.state;
    if (agentSet) return;

    fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      body: new URLSearchParams({
        action: 'fetch_agent',
        id: id
      })
    })
      .then(res => res.json())
      .then(
        agent => this.setState({ agent: agent, agentSet: true })
      )
      .catch(err => console.log(err))

  }

    fetchSecondaryAgent = (id) => {
        let { secondaryAgentSet } = this.state;
        if (secondaryAgentSet) return;

        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
            body: new URLSearchParams({
                action: 'fetch_agent',
                id: id
            })
        })
            .then(res => res.json())
            .then(
                agent => this.setState({ secondaryAgent: agent, secondaryAgentSet: true })
            )
            .catch(err => console.log(err))

    }

  fetchBuyerAgent = (id) => {
    if (!id) {
      return;
    }

    fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      body: new URLSearchParams({
        action: 'fetch_agent',
        id: id
      })
    })
      .then(res => res.json())
      .then(
        agent => this.setState({ buyerAgent: agent })
      )
      .catch(err => console.log(err))

  }



    render() {

        const property = this.props.property;
        const modal = this.props.modal;

        return (
            <div>
                {
                    !modal &&
                    <PropertyContentNav property={property} modal={modal} />
                }
                <div className={`desktop-container ${modal ? '' : 'container'}`}>
                    {this.state.addressForm &&
                        <div id="mailer-modal">
                            {/* Address */}
                            <div className="agent-address">
                                <img onClick={() => this.setState({ addressForm: false })} className="close-takeover" src="/wp-content/themes/hayden/assets/images/icons/white-x-lrg.svg" alt="close form" />
                                <h4 className="headline mb-3">Mailing Address</h4>
                                <p className='mailer-header'>Yes! Send me information by mail about this property.</p>
                                <p className='small'>(We do not sell leads to outside sources)</p>
                                <div className="form-fields">
                                    <div className={`profile-form-field ${this.state.addressErrors.street ? 'err' : ''}`}>
                                        <label htmlFor="street">Street</label>
                                        <input onChange={this.handleAddressChange} name="street" type="text" placeholder="Street" value={this.state.address.street} />
                                        <span className="required">Please enter a valid street name.</span>
                                    </div>
                                    <div className="profile-form-field">
                                        <label htmlFor="street_2">Additional</label>
                                        <input onChange={this.handleAddressChange} name="street_2" type="text" placeholder="Additional" value={this.state.address.street_2} />
                                    </div>
                                    <div className={`profile-form-field two-third pr-md-2 ${this.state.addressErrors.city ? 'err' : ''}`}>
                                        <label htmlFor="city">City</label>
                                        <input onChange={this.handleAddressChange} name="city" type="text" placeholder="City" value={this.state.address.city} />
                                        <span className="required">Please enter a valid city name.</span>
                                    </div>
                                    <div className={`profile-form-field select third pl-md-2 ${this.state.addressErrors.state ? 'err' : ''}`}>
                                        <label htmlFor="state">State</label>
                                        <select onChange={this.handleAddressChange} name="state" value={this.state.address.state} id="state">
                                            <option value="" disabled>State</option>
                                            <option value="AL">Alabama</option>
                                            <option value="AK">Alaska</option>
                                            <option value="AZ">Arizona</option>
                                            <option value="AR">Arkansas</option>
                                            <option value="CA">California</option>
                                            <option value="CO">Colorado</option>
                                            <option value="CT">Connecticut</option>
                                            <option value="DE">Delaware</option>
                                            <option value="DC">District of Columbia</option>
                                            <option value="FL">Florida</option>
                                            <option value="GA">Georgia</option>
                                            <option value="HI">Hawaii</option>
                                            <option value="ID">Idaho</option>
                                            <option value="IL">Illinois</option>
                                            <option value="IN">Indiana</option>
                                            <option value="IA">Iowa</option>
                                            <option value="KS">Kansas</option>
                                            <option value="KY">Kentucky</option>
                                            <option value="LA">Louisiana</option>
                                            <option value="ME">Maine</option>
                                            <option value="MT">Montana</option>
                                            <option value="NE">Nebraska</option>
                                            <option value="NV">Nevada</option>
                                            <option value="NH">New Hampshire</option>
                                            <option value="NJ">New Jersey</option>
                                            <option value="NM">New Mexico</option>
                                            <option value="NY">New York</option>
                                            <option value="NC">North Carolina</option>
                                            <option value="ND">North Dakota</option>
                                            <option value="OH">Ohio</option>
                                            <option value="OK">Oklahoma</option>
                                            <option value="OR">Oregon</option>
                                            <option value="MD">Maryland</option>
                                            <option value="MA">Massachusetts</option>
                                            <option value="MI">Michigan</option>
                                            <option value="MN">Minnesota</option>
                                            <option value="MS">Mississippi</option>
                                            <option value="MO">Missouri</option>
                                            <option value="PA">Pennsylvania</option>
                                            <option value="RI">Rhode Island</option>
                                            <option value="SC">South Carolina</option>
                                            <option value="SD">South Dakota</option>
                                            <option value="TN">Tennessee</option>
                                            <option value="TX">Texas</option>
                                            <option value="UT">Utah</option>
                                            <option value="VT">Vermont</option>
                                            <option value="VA">Virginia</option>
                                            <option value="WA">Washington</option>
                                            <option value="WV">West Virginia</option>
                                            <option value="WI">Wisconsin</option>
                                            <option value="WY">Wyoming</option>
                                        </select>
                                        <span className="required">Please select a state.</span>
                                    </div>
                                    <div className={`profile-form-field two-third pr-md-2 ${this.state.addressErrors.zip ? 'err' : ''}`}>
                                        <label htmlFor="zip">Postal Code</label>
                                        <input onChange={this.handleAddressChange} name="zip" type="text" placeholder="Zip" value={this.state.address.zip} />
                                        <span className="required">Please enter a valid zipcode.</span>
                                    </div>
                                    <div className="profile-form-field select third pl-md-2">
                                        <label htmlFor="country">Country</label>
                                        <select onChange={this.handleAddressChange} name="country" value={this.state.address.country} id="country">
                                            <option value="" disabled>Country</option>
                                            <option value="usa">United States</option>
                                            <option value="other">other</option>
                                        </select>
                                    </div>
                                    <button onClick={this.handleAddressSubmit} className="btn submit">Submit</button>
                                </div>

                            </div>
                            {/* End address */}
                        </div>
                    }
                    <div className="desktop-left">
                        {
                            modal &&
                            <div className="title-section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-8 col-md-12 px-md-5">
                                            <div className="d-none d-md-block" dangerouslySetInnerHTML={{ __html: property.listing_status_formatted }} />
                                            <h2 dangerouslySetInnerHTML={{ __html: property.title }}></h2>
                                            <p className="county">{property.loc_address['county'] ? property.loc_address['county'] + ', ' + property.full_state : property.full_state}</p>
                                        </div>
                                        <div className="col-4 d-md-none">
                                            <div dangerouslySetInnerHTML={{ __html: property.listing_status_formatted }} />
                                            {property.is_auction &&
                                                <div className="price">Auction</div>}
                                            {!property.is_auction &&
                                                <div className="price">{property.current_price_formatted ? '$' + property.current_price_formatted : ''}</div>}

                                        </div>
                                        <div className="d-none d-md-flex px-md-5 prop-details-dt">
                                            {property.is_auction &&
                                                <div>Auction</div>}
                                            {!property.is_auction &&
                                                <div>{'$' + property.current_price_formatted} <span>Price</span> </div>}

                                            <div>{property.total_combined_acres_formatted} <span>Acres</span> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            modal &&
                            <PropertyContentNav property={property} modal={modal} />
                        }
                        <Suspense fallback={<div>Loading Property</div>}>
                            <PropertyContent property={property} modal={modal} />
                        </Suspense>


                        <div className="contact-form d-md-none" id="agent-contact">
                            <AgentDetails agent={this.state.agent} secondaryAgent={this.state.secondaryAgent} />
                            <h3>Contact me today for more information on this property.</h3>
                            {!this.state.submitted &&
                                <div className="property-contact-form">
                                    <input type="text" name="firstName" placeholder="First Name" onChange={this.handleChange} value={this.state.firstName} />
                                    <input type="text" name="lastName" placeholder="Last Name" onChange={this.handleChange} value={this.state.lastName} />
                                    <input type="text" name="email" placeholder="Email Address" onChange={this.handleChange} value={this.state.email} />
                                    <input type="text" name="phone" placeholder="Phone Number" onChange={this.handleChange} value={this.state.phone} />
                                    <textarea name="message" placeholder="message" onChange={this.handleChange} value={this.state.message} />
                                    {this.state.displayMailerOption &&
                                        <div className="checkbox-container full" style={{ display: 'flex' }}>
                                            <input className="checkbox" style={{ marginRight: '10px' }} onClick={this.handleCheckbox} type="checkbox" name="mailer" checked={this.state.mailer} readOnly />
                                            <label htmlFor="mailer" style={{ fontSize: '14px', lineHeight: '1.2' }}>Yes! Send me property information via mail!</label>
                                        </div>
                                    }
                                    <div className="form-error">{this.state.rmiError}</div>
                                    <button disabled={this.state.submitButtonDisabled} onClick={this.handleSubmit} id="submit-property-contact" className="btn w-100">{this.state.submitButtonText}</button>
                                </div>}
                            {this.state.submitted &&
                                <p>Thank you for your submission. We will be in touch soon.</p>}
                        </div>
                        <div className="open-contact d-md-none w-100">
                            <button id="contact-agent" className={`btn ${modal ? 'is-modal' : ''}`}>Contact Agent</button>
                        </div>


                    </div>
                    <div className={`desktop-right d-none d-md-block ${modal ? 'pr-md-5' : 'pr-md-0'} `}>
                        {
                            (modal && property.post_status !== 'draft') &&
                            <div>
                                <Share property={property} togglePropertyDetailsModal={this.props.togglePropertyDetailsModal} favorites={this.props.favorites} refreshUser={this.props.refreshUser} />
                                <div className="text-right">
                                    <a href={property.permalink} className="btn view-listing">View Listing</a>
                                </div>
                            </div>
                        }

                        <div className={`sticky-container ${modal ? 'is-modal' : ''}`}>
                            <AgentDetails agent={this.state.agent} secondaryAgent={this.state.secondaryAgent} />

                            <div className={`contact-form d-none d-md-block`}>

                                <h3>Contact me today for more information on this property.</h3>
                                {!this.state.submitted &&
                                    <div className="property-contact-form">
                                        <input type="text" name="firstName" placeholder="First Name" onChange={this.handleChange} value={this.state.firstName} />
                                        <input type="text" name="lastName" placeholder="Last Name" onChange={this.handleChange} value={this.state.lastName} />
                                        <input type="text" name="email" placeholder="Email Address" onChange={this.handleChange} value={this.state.email} />
                                        <input type="text" name="phone" placeholder="Phone Number" onChange={this.handleChange} value={this.state.phone} />
                                        <textarea name="message" placeholder="message" onChange={this.handleChange} value={this.state.message} />
                                        {this.state.displayMailerOption &&
                                            <div className="checkbox-container full" style={{ display: 'flex' }}>
                                                <input className="checkbox" style={{ marginRight: '10px' }} onClick={this.handleCheckbox} type="checkbox" name="mailer" checked={this.state.mailer} readOnly />
                                                <label htmlFor="mailer" style={{ fontSize: '14px', lineHeight: '1.2' }}>Yes! Send me property information via mail!</label>
                                            </div>
                                        }
                                        <div className="form-error">{this.state.rmiError}</div>
                                        <button onClick={this.handleSubmit} id="submit-property-contact" className="btn">{this.state.submitButtonText}</button>
                                    </div>}
                                {this.state.submitted &&
                                    <p>Thank you for your submission. We will be in touch soon.</p>}
                            </div>
                          <div className='mt-4'>
                            {this.state?.buyerAgent?.id ? (
                                <>
                                  <div>Buyer Represented By:</div>
                                  <AgentInfo agent={this.state.buyerAgent} />
                                </>
                              ) : null
                            }
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
